{
  "primer": {
    "eyebrow": "Lokutan salla da Alƙibla",
    "headline": "Rhemn na buƙatar wurin da kake don lokutan salla da Alƙibla.",
    "body": "Muna amfani da shi ne kawai don lokutan sallarka, hanyar Alƙibla da yanayin wurinka — ba wani abu ba.",
    "cta": "Ci gaba",
    "skip": "Ba yanzu ba",
    "skip_body": "Lokutan salla da Alƙibla za su ci gaba da kashe."
  }
}
